import { DateTime } from "luxon";
import type {
  ReservationFormMainContext,
  ReservationFormMainEvent,
} from '../machines/reservationFormMain.types';
import { getTripsFromMachines } from "./getTripsFromMachines";

function shouldValidateReservation(
  context: ReservationFormMainContext,
  event?: ReservationFormMainEvent,
): boolean {
  // Ensure that we have at least the data construct required for a trip leg
  const trips = getTripsFromMachines(context);
  if (trips.length === 0) {
    return false;
  }
  const first = trips[0];
  if (!first) {
    return false;
  }

  // If the trip is will call, we should return true if the appointment date and pickup date are set. 
  // If the trip isn't will call, we should return true if the appointmentDateTime is valid.
  const guardHasAppointmentDateTimes = first.isWillCall ? (
    first.appointmentDate != null &&
    DateTime.fromISO(first.appointmentDate).isValid
  ) : (
    first.appointmentDateTime != null &&
    first.appointmentDateTime instanceof DateTime &&
    first.appointmentDateTime.isValid
  );

  return (
    guardHasAppointmentDateTimes
  );
}

export { shouldValidateReservation };
